var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('nav-bar'),_c('section',{staticClass:"main-content columns is-fullheight"},[_c('div',{staticClass:"column is-2 sidebar-container"},[_c('SideBarKnit')],1),_c('div',{staticClass:"column is-10"},[_c('div',{staticClass:"section"},[_c('router-view')],1)])]),_c('footer-bar')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }